import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('core');

export class Settings extends Api {
  constructor(http, config = {}) {
    super(http, url, 'configurations', config);
  }
}
